import t from"./setBreakpoint.js";import e from"./getBreakpoint.js";const o={setBreakpoint:t,getBreakpoint:e};export{o as default};
//# sourceMappingURL=index.js.map
